// The GoPeople student invitation steps answer { code, message, type }, and the
// rate limiter { error, type }. Their messages are technical English, so the
// cases a student can act on are matched on a fragment and translated; anything
// else is left to the invitation errors.
//
// The conflicts come first: their message carries the email or phone the student
// typed, which could itself contain "otp".
const STUDENT_ERRORS = [
  { fragment: "resource: email with value", key: "student_email_used" },
  { fragment: "resource: organization member", key: "student_already_member" },
  { fragment: "resource: phone with value", key: "student_phone_used" },
  {
    fragment: "validation of this invitation is in progress",
    key: "student_validation_in_progress",
  },
  { fragment: "being moved to another account", key: "student_merge_started" },
  // GoPeople's refusals of a badly formatted number: "a valid phone number is
  // required", "invalid phone number length", "phone number should contain only
  // digits".
  { fragment: "phone number", key: "student_phone_invalid" },
  // Its message also contains "invalid or expired", which the invitation errors
  // would read as an expired link.
  { fragment: "otp", key: "student_invalid_code" },
  { fragment: "not a student email", key: "student_personal_email_required" },
];

const messageOf = (error) =>
  (error?.response?.data?.message || "").toLowerCase();

// Returns the i18n key of the error, or null when it is not a student step case.
export const studentErrorKey = (error) => {
  if (
    error?.response?.status === 429 ||
    error?.response?.data?.type === "TOO_MANY_REQUESTS"
  ) {
    return "student_too_many_attempts";
  }
  const message = messageOf(error);
  const known = STUDENT_ERRORS.find((item) => message.includes(item.fragment));
  return known ? known.key : null;
};

// The link predates a phone validation: the phone step has nothing left to do.
export const isPhoneAlreadyValidated = (error) =>
  messageOf(error).includes("a phone is already validated");

// Accept refuses a student invitation until an email is validated: the page goes
// back to the email step.
export const isPersonalEmailRequired = (error) =>
  messageOf(error).includes("validate a personal email before accepting");
